module.exports = __webpack_public_path__ + "static/media/iconFour.2d0241d5.svg";